<template>
  <div
    class="w-full bg-white flex justify-center item-center border-b border-gray-12"
    :class="{ fixed: isFixed }"
    style="height: 56px"
  >
    <div class="flex items-center">
      <router-link :to="{ name: 'Login' }">
        <img src="@/assets/images/logo.svg" alt="PRONIアイミツメンバーズ" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const router = useRouter();

    const isFixed = computed(() => {
      return router.currentRoute.value.meta.isFixed || '';
    });

    return {
      isFixed,
    };
  },
};
</script>
